<template>
  <div class="athletes_photo" :style="{width:isSmallBoll?'100%':'1050px'}" style="border: 1px solid #999;">
    <header
      class="fonts_color headers"
      style="text-align: center;padding: 44px 0;color: #444;font-weight: 600;margin:0;"
    >
      <h1
        style="font-size: 24px;margin:0 0 14px;padding:0"
      >{{details.matchName?details.matchName:matchName}}</h1>
      <h2 style="font-size: 22px;padding:0;margin:0">{{userInfo.schoolName}}大学生参赛运动员</h2>
    </header>
    <template v-if="details.athleteList && details.athleteList.length > 0">
      <template v-if="userInfo.project !== 7 && !isSmallBoll">
        <template v-for="item in getShowNum">
          <!-- :style="{pageBreakAfter:item % 5 === 0?'always':''}" -->
          <!-- :class="[item !== 1 && item % 5 === 1?'margin_top':'']" -->
          <div class="rows" :key="item">
            <div class="top" style="width:100%;display:flex">
              <div
                class="right_border"
                :style="{borderRight:(index+1) == 5 ?'none':'1px solid #999'}"
                style="width:20%;box-sizing:border-box"
                v-for="(temp,index) in details.athleteList.slice((item - 1) * 5,item * 5)"
                :key="index + '_' + item"
                :class="[index === 0?'left_border':'',item === 1?'top_border':'',(index + 1) % 5 === 0?'export_pdf_right':'']"
              >
                <div style="display:flex;justify-content:center;align-items:center;">
                  <section style="padding:10px;">
                    <img class="photos" :src="temp.headImage" style="width:160px;height:170px;" alt />
                  </section>
                </div>
              </div>
            </div>
            <div class="bottom" style="width:100%;display:flex">
              <div
                class="right_border bottom_border"
                :style="{borderRight:(index+1) == 5 ?'none':'1px solid #999',borderBottom:item === getShowNum?'none':'1px solid #999'}"
                style="width:20%;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #999;border-left:none;padding:10px;box-sizing:border-box"
                v-for="(temp,index) in details.athleteList.slice((item - 1) * 5,item * 5)"
                :key="index + '-' + item"
                :class="[index === 0?'left_border':'',(index + 1) % 5 === 0?'export_pdf_right':'',item === getShowNum?'export_pdf_bottom':'']"
              >
                <p
                  class="athlete_info fonts_color"
                  style="margin:0 0 10px;font-size:18px;color:#444;display:flex;padding:0;"
                >
                  <span style="margin-right:16px">{{temp.signNumber}}</span>
                  <span style="max-width:140px;">{{temp.athleteName}}</span>
                </p>
                <p
                  class="register_number"
                  style="margin:0;padding:0;color:#444"
                >{{temp.registerNumber}}</p>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-else-if="isSmallBoll">
        <template v-for="item in getSmallBollNum">
          <div class="rows" :key="item">
            <div class="top" style="width:100%;display:flex">
              <div
                class="right_border"
                :style="{borderRight:(index+1) == 8 ?'none':'1px solid #999'}"
                style="width:15%;box-sizing:border-box"
                v-for="(temp,index) in details.athleteList.slice((item - 1) * 8,item * 8)"
                :key="index + '_' + item"
                :class="[index === 0?'left_border':'',item === 1?'top_border':'',(index + 1) % 8 === 0?'export_pdf_right':'']"
              >
                <div style="display:flex;justify-content:center;align-items:center;">
                  <section style="padding:10px;">
                    <img class="photos" :src="temp.headImage" style="width:70px;height:90px;" alt />
                  </section>
                </div>
              </div>
            </div>
            <div class="bottom" style="width:100%;display:flex">
              <div
                class="right_border bottom_border"
                :style="{borderRight:(index+1) == 8 ?'none':'1px solid #999',borderBottom:item === getSmallBollNum?'none':'1px solid #999'}"
                style="width:15%;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #999;border-left:none;padding:10px;box-sizing:border-box"
                v-for="(temp,index) in details.athleteList.slice((item - 1) * 8,item * 8)"
                :key="index + '-' + item"
                :class="[index === 0?'left_border':'',(index + 1) % 8 === 0?'export_pdf_right':'',item === getSmallBollNum?'export_pdf_bottom':'']"
              >
                <p
                  class="athlete_info fonts_color"
                  style="margin:0 0 10px;font-size:18px;color:#444;display:flex;padding:0;"
                >
                  <span style="margin-right:16px">{{temp.signNumber}}</span>
                  <span style="max-width:140px;">{{temp.athleteName}}</span>
                </p>
                <p
                  class="register_number"
                  style="margin:0;padding:0;color:#444;word-break:break-all;text-align:center;width:100%"
                >{{temp.registerNumber}}</p>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="rows" v-for="n in 5" :key="n">
          <div class="top" style="width:100%;display:flex">
            <div
              class="right_border"
              :style="{borderRight:(index+1) == 5 ?'none':'1px solid #999'}"
              style="width:20%;box-sizing:border-box"
              v-for="(temp,index) in details.athletePhotoList.slice((n - 1) * 5,n * 5)"
              :key="index + '_' + n"
              :class="[index === 0?'left_border':'',n % 5 === 1 || n === 1?'top_border':'',(index + 1) % 5 === 0?'export_pdf_right':'']"
            >
              <div style="display:flex;justify-content:center;align-items:center;">
                <section style="padding:10px;">
                  <img
                    v-if="temp.headImage"
                    class="photos"
                    :src="temp.headImage"
                    style="width:150px;height:170px;"
                    alt
                  />
                  <p v-else class="photos" style="width:150px;height:170px;margin:0;padding:0;"></p>
                </section>
              </div>
            </div>
          </div>
          <div class="bottom" style="width:100%;display:flex">
            <div
              class="right_border bottom_border"
              :style="{borderRight:(index+1) == 5 ?'none':'1px solid #999'}"
              style="width:20%;min-height:64px;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #999;border-left:none;padding:10px;box-sizing:border-box"
              v-for="(temp,index) in details.athletePhotoList.slice((n - 1) * 5,n * 5)"
              :key="index + '-' + n"
              :class="[index === 0?'left_border':'',(index + 1) % 5 === 0?'export_pdf_right':'',n === getShowNum?'export_pdf_bottom':'']"
            >
              <p
                class="athlete_info fonts_color"
                style="margin:0 0 10px;font-size:18px;color:#444;display:flex;padding:0;"
              >
                <span style="margin-right:16px">{{temp.signNumber}}</span>
                <span style="max-width:140px;">{{temp.athleteName}}</span>
              </p>
              <p style="margin:0;padding:0;">{{temp.registerNumber}}</p>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div
        style="height:200px;display:flex;align-items:center;justify-content:center;font-size:24px"
      >暂无数据</div>
    </template>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage.js";
export default {
  props: {
    details: {
      type: Object
    },
    matchName: {
      type: String
    }
  },
  data() {
    return {
      isRenders: false,
      userInfo: JSON.parse(getSession("userInfo")) || ""
    };
  },
  computed: {
    // 判断当前身份是否为羽毛球、网球、乒乓球管理员中的任意一位
    isSmallBoll() {
      let info = this.userInfo.project;
      return info === 1 || info === 5 || info === 6;
    },
    // 羽毛球、网球、乒乓球以10个为一排打印（横向打印）
    getSmallBollNum() {
      let num = 0;
      if (this.details.athleteList && this.details.athleteList.length < 8) {
        num = 1;
      } else if (
        this.details.athleteList &&
        this.details.athleteList.length >= 8
      ) {
        let length = this.details.athleteList.length;
        if (length / 8 > parseInt(length / 8)) {
          num = parseInt(length / 8) + 1;
        } else {
          num = length / 8;
        }
      }
      return num;
    },
    // 篮球、排球赛事 以5个为一排打印
    getShowNum() {
      let num = 0;
      if (this.details.athleteList && this.details.athleteList.length < 5) {
        num = 1;
      } else if (
        this.details.athleteList &&
        this.details.athleteList.length >= 5
      ) {
        let length = this.details.athleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
      }
      return num;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isRenders = true;
    });
  }
};
</script>
<style lang="less" scoped>
.athletes_photo {
  border: 1px solid #999;
  margin: 0 auto;
  > header {
    text-align: center;
    padding: 44px 0;
    color: #444;
    font-weight: 600;
    border-bottom: 1px solid #999;
    > h1 {
      font-size: 24px;
      margin-bottom: 14px;
    }
    > h2 {
      font-size: 22px;
    }
  }
}
</style>
<style>